<!-- Guest Pass List Tab -->
@if (showHeader()) {
  <div
    class="flex align-items-center justify-content-between cursor-pointer"
    pStyleClass="@next"
    enterFromClass="hidden"
    enterActiveClass="scalein"
    leaveToClass="hidden"
    leaveActiveClass="fadeout"
    [hideOnOutsideClick]="true"
    [attr.data-testid]="'guest-pass-list-header'"
  >
    <div class="flex align-items-center justify-content-center">
      <div
        class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center"
      >
        <i class="fa fa-id-card" [attr.data-testid]="'guest-pass-list-icon'"></i>
      </div>
      <div class="ml-3">
        <h4
          class="text-base mb-0 line-height-1 font-bold"
          [attr.data-testid]="'guest-pass-list-title'"
        >
          {{ 'GUEST_PASS.LIST.TITLE' | translate }}
        </h4>
        @if (loading) {
          <p-skeleton
            width="7rem"
            height="0.9rem"
            styleClass="mt-1"
            [attr.data-testid]="'guest-pass-list-skeleton'"
          />
        } @else {
          <p
            class="mb-0 text-xs text-600"
            [attr.data-testid]="'guest-pass-list-count'"
          >
            {{ (redemptionData$ | async)?.length }}
            {{ 'GUEST_PASS.LIST.ITEMS_COUNT' | translate }}
          </p>
        }
      </div>
    </div>
    <i
      class="fa fa-circle-chevron-down text-primary"
      [attr.data-testid]="'guest-pass-list-chevron'"
    ></i>
  </div>
}

<div
  [ngClass]="showHeader() ? 'hidden mt-2' : ''"
  [attr.data-testid]="'guest-pass-list-content'"
>
  <app-data-grid
    [columnData]="redemptionData$"
    [columns]="redemptionTableColumns$"
    [selectable]="false"
    (emitValue)="handleEvent($event)"
    (emitSelectValue)="handleSelectAll($event)"
    tableClasses="shadow-2 p-0 my-3"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
    [EmptyState]="emptyStateComponent$"
    [paginator]="false"
    [gridName]="'guest-pass-list'"
    [loading]="loading"
  />
</div>
<!-- Guest Pass List Tab -->
